export class AppError extends Error {
	constructor(message: string) {
		super(message);
		this.name = this.constructor.name;
	}
}

export class HttpError extends AppError {
	constructor(status: number, message: string) {
		super(message);
		this.status = status;
	}

	status: number;
}

export class AuthError extends HttpError {
	constructor(message = '인증이 만료되었어요') {
		super(401, message);
	}
}

export class NotFoundError extends HttpError {
	constructor(message = '찾을 수 없어요') {
		super(404, message);
	}
}

export class ServerError extends HttpError {
	constructor(status = 500, message = '서버 오류가 발생했어요') {
		super(status, message);
	}
}

export class NetworkError extends AppError {
	constructor(message = '네트워크 연결을 확인해주세요') {
		super(message);
	}
}

export class UnknownError extends AppError {
	constructor(message = '알 수 없는 오류가 발생했어요') {
		super(message);
	}
}
